import React from 'react';
import { IconProps } from '../types';
const MinecraftOminousBottle: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="6" y="2" width="1" height="1" fill="rgba(126, 69, 60, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(208, 148, 118, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(208, 148, 118, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(126, 69, 60, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(19, 37, 48, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(126, 69, 60, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(126, 69, 60, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(19, 37, 48, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(162, 98, 152, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(162, 98, 152, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(162, 98, 152, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="4" y="10" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="3" y="11" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="4" y="11" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(168, 0, 47, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(255, 0, 72, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(255, 0, 72, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(168, 0, 47, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="5" y="12" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(73, 51, 72, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="4" y="13" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="5" y="13" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(12, 6, 25, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(35, 31, 42, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(74, 200, 213, 255)" />
<rect x="5" y="14" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(30, 71, 82, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(58, 120, 127, 255)" />
</svg>);
export default MinecraftOminousBottle;